const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { ensureNamespaceLoaded } from '@/lib/translations/i18nloader';
export const Route = createFileRoute('/(app)/org/$org/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async () => {
    await ensureNamespaceLoaded('homepage');
  }
});